import * as React from 'react';
import clsx from 'clsx';

/** Props for `ToggleSwitch`. Pure controlled component — caller owns `checked`. */
export interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
}

/** Pill-style on/off switch (larger and more visible than a native checkbox). */
export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  ariaLabel,
  className,
}) => (
  <button
    type='button'
    role='switch'
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={clsx(
      'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors',
      'focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2',
      disabled && 'cursor-not-allowed opacity-50',
      checked ? 'bg-black' : 'bg-gray-300',
      className
    )}
  >
    <span
      className={clsx(
        'inline-block size-5 rounded-full bg-white shadow transition-transform',
        checked ? 'translate-x-5' : 'translate-x-0.5'
      )}
    />
  </button>
);
